export default {
  hasSelection: state => state.selectedIds.length > 0,
  selectedCount: state => state.selectedIds.length,
};
